module.exports = __webpack_public_path__ + "img/1570358378.bff47aab.jpg";